import { render, staticRenderFns } from "./PermissionManagement.vue?vue&type=template&id=a70e1956&scoped=true"
import script from "./PermissionManagement.vue?vue&type=script&lang=js"
export * from "./PermissionManagement.vue?vue&type=script&lang=js"
import style0 from "./PermissionManagement.vue?vue&type=style&index=0&id=a70e1956&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a70e1956",
  null
  
)

export default component.exports